import React from 'react'
import { Form, Input, FormGroup, FormText } from 'reactstrap'
// import{ AiOutlineSearch} from 'react-icons/ai'
import searchIcon from '../../../Assets/outline-interface-search.png'
import crossIcon from '../../../Assets/group-383.png'
// import { RxCross2 } from 'react-icons/rx'
// import { TextInput } from 'react-native-gesture-handler'
export default function SearchBar(props) {
//    console.log('SearchBar props', props)
    return (
            <div style={{ flexDirection: 'row', display: 'flex', height: 48,width: props.width,position:'relative' }}>
                {/* <div style={searchIconStyle}> */}
                    <img src={searchIcon} style={searchImgStyle} />
                {/* </div> */}
                <Input
                    // placeholderTextColor='#9d9d9d'
                    style={searchBoxOfferStyle}
                    onChange={props.onChange}
                    value={props.value}
                    placeholder={props.placeholder}
                    onSubmitEditing={props.onSubmitEditing}
                    // returnKeyType={props.returnKeyType}
                    className='shadow-none'
                    id="inputID"
                    maxLength={props.maxLength || 50}
                    
                />
                <div style={micStyle}>
                    {
                        props.searchTextService && <div style={{ justifyContent: 'center',backgroundColor: 'white',cursor:'pointer' }} onClick={props.onClickCross}>
                            <img src={crossIcon} onClick={props.onPressCross} style={searchImgStyle} />
                        </div>
                    }
                </div>
            </div>
)
}
let searchImgStyle = {
    width: 18,
    height: 18,
     left:20,
    top:15,
    right:12,
    marginRight:-10,
    zIndex:1,
    position:'absolute'

    // flexGrow: 0,
    // margin: 0 16px 0 0;
}
let searchIconStyle = {
    left:20,
    top:20,
    right:12,
    marginRight:-10,
    zIndex:1,
    position:'absolute',
    // flexDirection: 'row',
    // display: 'flex',
    // justifyContent: 'center',
    // alignItems: 'center',

}
let micStyle = {
    position:'absolute',
    // left:10,
    top:12,
    right:12
}
let searchBoxOfferStyle = {
    height: 48,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    gap: 8, 
    padding: 12,
    paddingLeft:45,
    borderRadius: 12,
    border: 'solid 1 #e8e8e8',
    backgroundColor: '#fff',
    fontFamily: "Inter",
    fontSize: 12,
    fontWeight: "bold",
    fontStyle: "normal",
    letterSpacing: 0,
    color: "#9f9f9f",
}
    // borderShadow: 'none'

    // placeholderTextColor:'rgb(157, 157, 157)'
